import { ICloseModalAction } from "../interfaces/modal.interface";

export function closeModal(): ICloseModalAction {
  return {
    type: "CLOSE_MODAL",
  };
}
